import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function RouteScrollReset() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // Preserve explicit section links; ordinary page navigation starts at the top.
    if (hash) {
      let sectionId = hash.slice(1);
      try { sectionId = decodeURIComponent(sectionId); } catch { /* Use the literal fragment if malformed. */ }
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: 'instant' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
